import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth, homeFor } from "@/context/AuthContext";
import AdminLayout from "@/components/AdminLayout";
import PortalLayout from "@/components/PortalLayout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import PaymentResult from "@/pages/PaymentResult";
import Dashboard from "@/pages/admin/Dashboard";
import Students from "@/pages/admin/Students";
import StudentDetail from "@/pages/admin/StudentDetail";
import CheckIn from "@/pages/admin/CheckIn";
import Attendance from "@/pages/admin/Attendance";
import Finance from "@/pages/admin/Finance";
import Plans from "@/pages/admin/Plans";
import Graduation from "@/pages/admin/Graduation";
import Contracts from "@/pages/admin/Contracts";
import Products from "@/pages/admin/Products";
import Users from "@/pages/admin/Users";
import SettingsPage from "@/pages/admin/Settings";
import Announcements from "@/pages/admin/Announcements";
import PortalHome from "@/pages/portal/PortalHome";
import PortalCheckin from "@/pages/portal/PortalCheckin";
import PortalGraduation from "@/pages/portal/PortalGraduation";
import PortalFinance from "@/pages/portal/PortalFinance";
import PortalProfile from "@/pages/portal/PortalProfile";

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm text-slate-500" data-testid="auth-loading">Carregando…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`} replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return children;
}

function Root() {
  const { user } = useAuth();
  if (user === null) return null;
  return <Navigate to={user ? homeFor(user) : "/login"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/login" element={<Login />} />
          <Route path="/redefinir-senha" element={<ResetPassword />} />
          <Route path="/pagamento/:result" element={<PaymentResult />} />
          <Route path="/admin" element={<Guard roles={["admin", "professor"]}><AdminLayout /></Guard>}>
            <Route index element={<Guard roles={["admin"]}><Dashboard /></Guard>} />
            <Route path="checkin" element={<CheckIn />} />
            <Route path="alunos" element={<Students />} />
            <Route path="alunos/:id" element={<StudentDetail />} />
            <Route path="frequencia" element={<Attendance />} />
            <Route path="graduacao" element={<Graduation />} />
            <Route path="comunicados" element={<Announcements />} />
            <Route path="financeiro" element={<Guard roles={["admin"]}><Finance /></Guard>} />
            <Route path="planos" element={<Guard roles={["admin"]}><Plans /></Guard>} />
            <Route path="contratos" element={<Guard roles={["admin"]}><Contracts /></Guard>} />
            <Route path="estoque" element={<Guard roles={["admin"]}><Products /></Guard>} />
            <Route path="usuarios" element={<Guard roles={["admin"]}><Users /></Guard>} />
            <Route path="configuracoes" element={<Guard roles={["admin"]}><SettingsPage /></Guard>} />
          </Route>
          <Route path="/portal" element={<Guard roles={["aluno", "responsavel"]}><PortalLayout /></Guard>}>
            <Route index element={<PortalHome />} />
            <Route path="checkin" element={<PortalCheckin />} />
            <Route path="graduacao" element={<PortalGraduation />} />
            <Route path="financeiro" element={<PortalFinance />} />
            <Route path="perfil" element={<PortalProfile />} />
          </Route>
          <Route path="*" element={<Root />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
